// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"loader_loader-wrapper__3VL-k"};